import React from 'react';

// eslint-disable-next-line no-unused-vars
const SinPermisos = props => (
  <div style={{ textAlign: 'center', marginTop: 20 }}>
    <h1>Disculpe, usted no posee autorización para ingresar en esa pagina.</h1>
    <h4>En caso de necesitar permisos, debe hablar con su supervisor.</h4>
  </div>
);

export default SinPermisos;
